import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import Home from "./routes/Home";
import Events from "./routes/Events";
import Event from "./routes/Event";
import CategoryResults from "./routes/CategoryResults";
import Watch from "./routes/Watch";
import "./index.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: "events", element: <Events /> },
      { path: "event/:eventId", element: <Event /> },
      { path: "event/:eventId/c/:catId", element: <CategoryResults /> },
      { path: "watch", element: <Watch /> },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
